import { render, staticRenderFns } from "./SettingPwd.vue?vue&type=template&id=2e1119de&scoped=true"
import script from "./SettingPwd.vue?vue&type=script&lang=js"
export * from "./SettingPwd.vue?vue&type=script&lang=js"
import style0 from "./SettingPwd.vue?vue&type=style&index=0&id=2e1119de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1119de",
  null
  
)

export default component.exports